import { Apis } from "libs/apis";
import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";
import { StripeToWiseTransferDTO } from "utils/helpers/models/stripeToWiseTransfer.dto";

interface Filters {
  offset?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
}

export const useWiseTransfers = () => {
  const getTransfers = async (
    setData: React.Dispatch<React.SetStateAction<any[]>>,
    filters: Filters,
    setPaginationState: Function
  ) => {
    const queryParamsObj: any = {
      offset: String(filters.offset || 0),
      limit: String(filters.limit || 10),
    };

    // Only add date filters if both are provided
    if (filters.startDate && filters.endDate) {
      queryParamsObj.startDate = filters.startDate;
      queryParamsObj.endDate = filters.endDate;
    }

    const queryParams = new URLSearchParams(queryParamsObj).toString();

    await Apis.getStripeToWiseTransfers(queryParams)
      .then((res) => {
        console.log("API Response:", res.data);
        // Handle different response structures
        const transfersData = res.data?.data || [];
        const paginationData = res.data?.pagination || { total: 0, limit: filters.limit || 10, offset: filters.offset || 0, pages: 0 };
        
        setData(Array.isArray(transfersData) ? transfersData : []);
        setPaginationState(paginationData);
      })
      .catch((error) => {
        console.error("Error fetching transfers:", error);
        console.error("Error response:", error.response?.data);
        // Set empty data on error
        setData([]);
        setPaginationState({ total: 0, limit: filters.limit || 10, offset: filters.offset || 0, pages: 0 });
      });
  };

  const getTransferById = async (id: number | null, setData: any) => {
    if (!id) return;
    await Apis.getStripeToWiseTransferById(id)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const postTransfer = async (body: { amount: number; date: string }) => {
    await Apis.postStripeToWiseTransfer(body)
      .then((res) => {
        // Handle both string and boolean status
        if (res.data.status === true || res.data.status === "success" || res.data.status === "Success") {
          dispatch(setModalClosed("WiseTransfers"));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const putTransfer = async (
    id: number,
    body: { amount?: number; date?: string }
  ) => {
    await Apis.putStripeToWiseTransfer(id, body)
      .then((res) => {
        // Handle both string and boolean status
        if (res.data.status === true || res.data.status === "success" || res.data.status === "Success") {
          dispatch(setModalClosed("WiseTransfers"));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return {
    getTransfers,
    postTransfer,
    getTransferById,
    putTransfer,
  };
};

